import { useQuery } from "@tanstack/react-query";
import { moduleSettingService } from "../shared/api/moduleSettingService";

export const useModuleSettings = () => {
	const { data, isLoading } = useQuery({
		queryKey: moduleSettingService.baseKey,
		queryFn: () => moduleSettingService.show().then((r) => r.data.data),
	});

	return {
		moduleSettings: data,
		isLoading,
	};
};
